'use strict';
import moment from 'moment';
import $ from 'jquery';
/**
 * there are more than a hand full of time pickers for bootstrap. But this is the best looking one that doesn't break the
 * layout of our locations page. https://www.npmjs.com/package/eonasdan-bootstrap-datetimepicker. On the raw bootstrap 3 with datetimepicker 4. https://github.com/eonasdan/bootstrap-datetimepicker.
 */

// Custom css for cmtimepicker under _locations.scss (does not affect cmdatetimepicker)


angular.module('clientDashboardApp').directive('cmtimepicker', function (uibDateParser) {
  return {
    restrict: 'E',
    require: ['^form'],
    scope: {
      model: '=',
      timefield: '=',
      placeholder: '@',
      required: '=',
      opentime: '=',
      closetime: '=',
      validationFtn: '=',
      hidehours:'='
    },
    template: `
          <input type="text" class="form-control can-have-square-corners"
           ng-model="model" ng-hide="hidehours"  ng-required="!hidehours" placeholder="{{placeholder}}"
          />
`,
    link(scope, element, attrs, [ formController ]) {

        $(element).datetimepicker({
          stepping:15,
          format: 'LT',
          widgetPositioning: {
            vertical: "top",
            horizontal: "left"
          },
          //Play nice with BS4
          icons: {
            time: "far fa-clock",
            date: "far fa-calendar-alt",
            up: "far fa-chevron-up",
            down: "far fa-chevron-down",
            previous: "far fa-chevron-left",
            next: "far fa-chevron-right"
          },
          allowInputToggle: true,
          focusOnShow: true
        }).on('dp.change', (e) => {
          scope.model = moment(e.date._d).format("hh:mm A");
          if (scope.validationFtn) {scope.validationFtn()};
          formController.$setDirty()

        })
          .on('dp.error', (err) => {
            console.log("error in date picker", err)
          })
    },//link
    controller($scope){
      //to check start and time are chronological
      $scope.isValidTimeRange = (timefield, open = false, close = false) => {
        const mTimeField = moment(timefield, "hh:mm a")
        //when closetime is passed timefield is open-time
        if (close) {
          const mClose = moment(close, "hh:mm a");
          return mTimeField.isBefore(mClose)
        }
        //when open is passed timefield is close-time
        if (open) {
          const mOpen = moment(open, "hh:mm a");
          return mTimeField.isAfter(mOpen)
        }
        console.log("was not able to validate range")
        $scope.$apply();
      };

    }//controller

  };//return
});
